import { Image } from './image';
import { Content } from './content';
export class AboutInfo {
  images: Image[] = [];

  title: string;
  leftContent: Content;
  rightContent: Content;

  constructor(public data: any) {
    const json: JSON = data['about'];

    for (const image of json['images']) {
      this.images.push(new Image(image));
    }

    if (json['leftContent']) {
      this.leftContent = new Content(json['leftContent']);
    }

    if (json['rightContent']) {
      this.rightContent = new Content(json['rightContent']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/about-info.ts